import axios from "axios";
import appSettings from "../appSettings";

//axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const apiUrl = `${appSettings.serverUrl}/api`;

let _accessToken: string | undefined;

axios.defaults.baseURL = apiUrl;

axios.interceptors.response.use(undefined, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!expectedError) {
    console.log("Logging the error", error);
  }
  return Promise.reject(error); // return control to the catch blocks
});

const setAccessToken = (accessToken: string) => {
  _accessToken = accessToken;
  axios.defaults.headers.common = {
    Authorization: `Bearer ${accessToken}`,
  };
};

const removeAccessToken = () => {
  delete axios.defaults.headers.common["Authorization"];
};

const getApiUrl = (): string => {
  return apiUrl;
};

const getAccessToken = () => {
  return _accessToken;
};

const httpService = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setAccessToken,
  removeAccessToken,
  getApiUrl,
  getAccessToken,
};

export default httpService;
